
import { Vue, Component } from 'vue-property-decorator'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'

@Component({
    components: { ToolbarComponent },
})
export default class UserSettingsIndex extends Vue {}
